// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-schedule__title{margin:0 0 25px 0;font-size:30px;line-height:36px}@media (max-width:575.98px){.streams-schedule__title{margin:0 0 14px 0;font-size:22px;line-height:26px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
